export const asyncStatus = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  ERROR: "error",
};


export const type_constant = {
  LOGIN: "LOGIN",
  SIGNUP: "SIGNUP",
  SIGNUP_VENDOR: "SIGNUP_VENDOR",
  SIGNUP_SERVICES_GET: "SIGNUP_SERVICES_GET",
  ADD_SERVICE: "ADD_SERVICE",
  GET_SERVICES_LIST: "GET_SERVICES_LIST",
  EDIT_SERVICES: "EDIT_SERVICES",
  DELETE_SERVICE: "DELETE_SERVICE",
  CREATE_SERVICE_OFFER: "CREATE_SERVICE_OFFER",
  ADD_ADDITIONAL_SERVICE_OFFER: "ADD_ADDITIONAL_SERVICE_OFFER",
  GET_USERS_LIST: "GET_USERS_LIST",
  GET_USERS_LIST_BY_ROLE: "GET_USERS_LIST_BY_ROLE",
  GET_ADDONS_LIST: "GET_ADDONS_LIST",
  DELETE_ADDONS_LIST: "DELETE_ADDONS_LIST",
  GET_OFFERS_LIST: "GET_OFFERS_LIST",
  DELETE_OFFERS_BY_ID: "DELETE_OFFERS_BY_ID",
  CHECK_AUTH:"CHECK_AUTH",
  GET_USER_BY_ID:"GET_USER_BY_ID",
  
  GET_DASHBOARD_DATA:"GET_DASHBOARD_DATA",
  ADD_VENDOR_ASYNC:"ADD_VENDOR_ASYNC",

  GET_USER_JOB_ID_ASYNC:"GET_USER_JOB_ID_ASYNC",
  GET_ALL_USERS_JOBS_ASYNC:"GET_ALL_USERS_JOBS_ASYNC",

  CHANGE_VENDOR_ASYNC:"CHANGE_VENDOR_ASYNC",

  GET_VENDOR_STATUS_ASYNC:"GET_VENDOR_STATUS_ASYNC",

  UPDATE_USER_BY_ID : "UPDATE_USER_BY_ID",
    GET_ALL_COUPONS_ASYNC: "coupons/getAllCouponsAsync",
    GET_COUPON_BY_ID_ASYNC: "coupons/getCouponByIdAsync", 
    CREATE_COUPON_ASYNC: "coupons/createCouponAsync",
    UPDATE_COUPON_ASYNC: "coupons/updateCouponAsync",
    DELETE_COUPON_ASYNC: "coupons/deleteCouponAsync",
    GET_NOTES_LIST: "GET_NOTES_LIST",
    GET_NOTES_BY_USER: "GET_NOTES_BY_USER",
    SEARCH_NOTES_BY_USER: "SEARCH_NOTES_BY_USER",
    ADD_NOTE_ASYNC: "ADD_NOTE_ASYNC",
    EDIT_NOTE_ASYNC: "EDIT_NOTE_ASYNC",
    DELETE_NOTE_ASYNC: "DELETE_NOTE_ASYNC",
    GET_SUBSCRIPTIONS: "GET_SUBSCRIPTIONS",
    CANCEL_SUBSCRIPTION: "CANCEL_SUBSCRIPTION",
    ADD_SUBSCRIPTION: "ADD_SUBSCRIPTION",
    GET_ANALYTICS: "GET_ANALYTICS",
    BROADCAST_NOTIFICATION: "BROADCAST_NOTIFICATION",
    GET_NOTIFICATIONS_HISTORY: "GET_NOTIFICATIONS_HISTORY",
}


export const save_tokens_constant = {
  AUTH:"auth"
}